export default "__VITE_ASSET__DFwqMOe9__"